import ContratoItem from "./ContratoItem";
class Contrato {
  "id": Number = 0;
  "grupo": String = "";
  "numeroContrato": String = "";
  "codigoFornecedorSAP": Number = 0;
  "freqAtualPrecM": Number = 0;
  "multaAcordada": Number = 0;
  // "projeto": String = "";
  "inicioVigencia": Date = new Date();
  "finalVigencia": Date = new Date();
  "modalidadeFrete": String = "";
  "itensContrato": ContratoItem[] = [];
  "criadoEm": Date = new Date();
  "excluidoEm": Date = new Date();
  "d_E_L_E_T_E": boolean = false;
}
export default Contrato;
